import { createStyles, makeStyles } from '@mui/styles'
import type { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    grid: {
      minHeight: 200,
      width: '100%',
      backgroundColor: '#ebebeb',
      borderRadius: 10,
      alignContent: 'flex-start',
      padding: '10px 0 10px 0',
      display: 'flex',
      flexDirection: 'column'
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    content: {
      flex: 'auto'
    },
    cover: {
      width: 151
    },
    editcard: {
      backgroundColor: '#EEEEEE'
    },
    errorcard: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      backgroundColor: '#FFC4C4'
    },
    columnTitle: {
      fontWeight: 'bold'
    },
    redButton: {
      backgroundColor: '#FF0000',
      color: '#FFFFFF'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    listelementtext: {
      padding: 0,
      margin: 0
    },
    actionButton: {
      marginTop: '10px'
    }
  })
)
